import nuskin from './namespace.js'; // import global namespace we can attach to
import RunConfigService from './runConfigService';
import _ from 'lodash';

/**
 * Fetch the runtime configuration environment variable for:
 * LOCAL || DEV || TEST || STAGE || PROD
 *
 * This function ensures there is a valid runtime config env. If none
 * is detected return a null.
 *
 * @returns runConfigEnv || null
 */
function getRunConfigEnv() {
    var runConfigEnv = RunConfigService.getEnvironment();
    // Ensure that the acquired run-config env matches one of the following
    // predefined environment modes, else just return null:
    switch(runConfigEnv) {
        case RunConfigService.LOCAL:
            return "http://" + RunConfigService.LOCAL;
        case RunConfigService.DEV:
            return "https://" + RunConfigService.DEV;
        case RunConfigService.TEST:
            return "https://" + RunConfigService.TEST;
        case RunConfigService.STAGE:
            return "https://" + RunConfigService.STAGE;
        case RunConfigService.PROD:
            return "https://" + RunConfigService.PROD;
        default:
            return null;
    }
}

/**
 * This function takes a configuration object with at least an env that conforms to
 * one of the following:
 *
 * dev || test || prod
 *
 * and sets the baseUrl according to the env variable.
 *
 * @param config
 * @return void if no config.env is detected
 */
function setConfigBaseUrl(config) {
    if (!config.env) {
        return;
    } else if (config.env === 'dev') {
        config.baseUrl = "https://dev.nuskin.com";
    } else if (config.env === 'test') {
        config.baseUrl = "https://test.nuskin.com";
    } else if (config.env === 'prod') {
        config.baseUrl = "https://www.nuskin.com";
    }
}

/**
 * Smart initialization function that detects if a the runtime env is overriden through the passed in
 * config object. If so then set the base url in the runtime config accordingly, else detect the runtime
 * config and set the base url off of that. If a base url is already set, do not override it.
 * This gives programmers the ability to override the runtime config env and base url as well as add
 * any additional configurations.
 *
 * @param config
 */
nuskin.init = (config) => {
    if (config.env) {
        setConfigBaseUrl(config);
        delete(config.env);
    } else if (!config.baseUrl) {
        config.baseUrl = getRunConfigEnv();
    }

    var runConfig = RunConfigService.getRunConfig();
    var extendedRunConfig = _.extend(runConfig, config);

    nuskin.util.Initializer.init(extendedRunConfig);
};

export default nuskin.init;
